module.exports = __webpack_public_path__ + "img/success-icon.53d5409c.svg";